<template lang="html">
  <div id="description-page">
    <section class="breadcrumb-section">
      <div class="container oversized-container">
        <span>Home</span>
        <span class="line">/</span>
        <router-link :to="'/productos/'+$root._converToURL(product.category, product.category_id)">{{product.category}}</router-link>
        <span class="line">/</span>
        <router-link :to="'/productos/'+$root._converToURL(product.category, product.category_id)+'/'+$root._converToURL(product.subcategory, product.subcategory_id)">{{ product.subcategory }}</router-link>
        <span class="line">/</span>
        <span>{{ product.name }}</span>
      </div>
    </section>

    <section class="container oversized-container description-section" id="product-description" v-if="isLoading == false">
      <div class="row">

        <div class="col-lg-6 mb-3 mt-lg-0 col-gallery">
          <swiper :options="galleryOptions" v-if="showGallery">
            <swiper-slide v-for="(row, galIndex) in gallery" :key="galIndex">
              <div class="image-container">
                <div class="img">

                  <v-zoom :img="row" :width="'100%'"></v-zoom>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>

          <div v-for="(tag,indx) in product.labels" :key="indx">
            <p class="text-center" style="margin-top: 10px;"><span class="bubble ":style="'background-color:'+tag.color_code+';top:'+tag.toppx+';position:static;font-size:1rem'">{{ tag.name }}</span>
            </p>
            <p class="mt-2">
              {{ tag.description }}
            </p>
          </div>
        </div>

        <b-form class="col-lg-5 col-description" @submit="addCart">
          <h1 class="name">{{ product.name }}</h1>
          <h6 class="sku"><strong>SKU:</strong> {{ sku_model }}</h6>
          <!-- <h6 class="sku">
            <strong>Categorías:</strong>
            <span><router-link to="">Nombre de la categoría x</router-link> </span>
            <span><router-link to="">Otra categoría</router-link> </span>
          </h6> -->

          <!-- <h6 class="price discount" v-if="product.price_discount != null">
            <span>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_orig) }}</span>
          </h6>
          <h4 class="price" v-if="product.price_discount != null">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price_discount) }}</h4>
          <h4 class="price" v-else>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h4> -->

          <h4 class="mt-3 price" v-if="price != null" >
            <span v-if="price_orig != null" style="text-decoration:line-through;">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price_orig) }} </span>
            <span>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(price) }} </span><br />
          </h4>
          <h4 class="model">{{ form.models_name }}</h4>

          <div class="mt-4 txt-description"  v-html="description"></div>

          <!-- <div class="mt-4 txt-description"  v-html="product.description"></div> -->

          <div v-if="form.models_id">
            <h6 class="mt-4 subtitle" v-if="stock > 0">Stock disponible: <span class="txt-red">{{stock}}</span> </h6>
            <h6 class="mt-4 subtitle" v-else>Sin stock</h6>
          </div>

          <div class="col-quantity2 mt-2">
            <a class="form-control btn-q" @click="changeCantidad('-')">
              <i class="fas fa-minus"></i>
            </a>
            <b-form-input class="input-q" type="number" min="0" v-model="form.quantity" @keypress="isNumber($event)" @paste="noPaste" />
            <a class="form-control btn-q" @click="changeCantidad('+')">
              <i class="fas fa-plus"></i>
            </a>
          </div>

          <div class="d-block mt-4 mb-2">
            <b-button type="submit" class="my-2 my-xl-0 btn-style-1 bg-green"> Agregar al carrito</b-button>
          </div>

          <h6 class="mt-4 c-pointer subtitle c-pointer" @click="showModels = !showModels">Presentaciones <small class="fas " v-bind:class="[ showModels ? 'fa-chevron-up' : 'fa-chevron-down' ]"></small></h6>
          <b-collapse :visible="showModels" class="mt-1">
            <div class="mt-2 table-responsive">
              <table class="table table-sm table-pres" id="tablemodels" v-if="product.models.length > 0">
                <thead>
                  <tr>
                    <th></th>
                    <th>Nombre</th>
                    <th style="min-width: 105px;">Precio</th>
                    <th>Existencia</th>
                    <th>COA</th>
                    <th v-if="product.distilled_active == true">Destilado</th>
                    <th v-if="product.terpene_active == true">Terpano</th>
                    <th v-if="product.flavor_active == true">Sabor</th>
                    <th v-if="product.concentration_active == true">Concetrado</th>
                    <th v-if="product.indica_sativa_active == true">Indica / Sativa</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(model,indx) in product.models" :key="indx" @click="changeModelid(indx, model.id)" style="cursor: pointer;">
                    <td>
                      <div class="custom-control custom-radio" style="padding-top: 8px; padding-bottom: 8px;">
                        <input style="position: relative;transform: scale(1.5);" type="radio" :id="'model'+indx" :name="model.id" :value="model.id" v-model="form.modelo">

                        <!-- <label class="custom-control-label"></label> -->
                      </div>
                    </td>

                    <td>{{model.name}}</td>
                    <td>
                      $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(model.price) }}
                    </td>
                    <td class="text-center">{{model.stock}}</td>
                    <td class="text-center"><a v-if="model.filecoa != null" class="btn btn-danger btn-sm" :href="model.filecoa" target="_blank"><i class="fa fa-file-pdf"></i></a></td>
                    <td v-if="product.distilled">{{model.distilled}}</td>
                    <td v-if="product.terpene">{{model.terpene}}</td>
                    <td v-if="product.flavor">{{model.flavor}}</td>
                    <td v-if="product.concentration">{{model.concentration}}</td>
                    <td v-if="product.indica_sativa">{{model.indica_sativa}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </b-collapse>



          <div v-if="id == 41">


            <b-form-group class="custom-input" label="Nombre o empresa:" label-for="i-nombre">
              <b-form-input id="i-nombre" type="text" v-model="formcomatografia.company" size="sm"  />
            </b-form-group>
            <b-form-group class="custom-input" label="Descripción de la muestra:" label-for="i-nombre">
              <b-form-input id="i-nombre" type="text" v-model="formcomatografia.description" size="sm"  />
            </b-form-group>
            <b-form-group class="custom-input" label="Referencia del cliente: * Nombre comercial que se le da al producto o muestra." label-for="i-nombre">
              <b-form-input id="i-nombre" type="text" v-model="formcomatografia.reference" size="sm"  />
            </b-form-group>
            <b-form-group class="custom-input" label="Peso del producto" label-for="i-nombre">
              <b-form-input id="i-nombre" type="text" v-model="formcomatografia.weight" size="sm"  />
            </b-form-group>
            <b-form-group class="custom-input" label="Miligramos en producto: (Opcional) 250mg CBD Aislado en total, 25mg CBD Aislado por pieza." label-for="i-nombre">
              <b-form-input id="i-nombre" type="text" v-model="formcomatografia.ml" size="sm"  />
            </b-form-group>
            <b-form-group class="custom-input" label="Lote: *En caso de no contar con uno, favor de asignar uno (Ej. ED4500098 – 0001)" label-for="i-nombre">
              <b-form-input id="i-nombre" type="text" v-model="formcomatografia.lote" size="sm"  />
            </b-form-group>
            <b-form-group class="custom-input" label="Datos que consideren necesario para su producto: (Opcional)" label-for="i-nombre">
              <b-form-input id="i-nombre" type="text" v-model="formcomatografia.comments" size="sm"  />
            </b-form-group>
            <b-form-group class="custom-input" label="Nō de guía y Paquetería: (Opcional)Añadir numero de guía y paquetería por donde viaja el paquete, puede omitirlo y enviar la información una vez generada su guía." label-for="i-nombre">
              <b-form-input id="i-nombre" type="text" v-model="formcomatografia.no_guide" size="sm"  />
            </b-form-group>
          </div>


          <!-- <h6 class="mt-3 c-pointer subtitle" @click="showDescr = !showDescr">Descripción <small class="fas " v-bind:class="[ showDescr ? 'fa-chevron-up' : 'fa-chevron-down' ]"></small></h6>
          <b-collapse :visible="showDescr" class="mt-1">
            <div class="txt-description"  v-html="product.description"></div>
          </b-collapse> -->

          <div class="d-block mt-4 mb-2" v-if="product.documentUrl">
            <a class="btn btn-style-1 btn-contact" v-if="product.documentUrl" :href="product.documentUrl" target="_blank" rel="noopener noreferrer">Descargar ficha técnica <i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
          </div>

          <!-- <h6 class="mt-2 mb-1 subtitle" v-if="product.tablaPrecios">Lista de precios</h6>
          <img class="img-fluid" :src="product.tablaPrecios"> -->

          <h6 class="mt-3 subtitle" v-if="product.delivery_time_custom && product.type == 'producto'">Tiempo de entrega</h6>
          <h4 class="delivery-time" v-if="product.delivery_time_custom && product.type == 'producto'">{{ product.delivery_time_custom }}</h4>


          <!-- <div class="d-block mt-4 mb-2">
            Debes de seleccionar una presentacion
          </div> -->

          <div class="pt-1 box-extra-buttons">
            <hr />

            <div class="d-block my-1"  v-for="(doc, pdInx) in product.documents" :key="'docc-'+pdInx">
              <a class="btn btn-style-1 outline-green" target="_blank" :href="doc.documentUrl"> {{doc.name}}</a>
            </div>

            <div class="d-block my-1" v-if="documentUrlCertificate">
              <a class="btn btn-style-1 outline-green" target="_blank" :href="documentUrlCertificate">Certificado COA</a>
            </div>
          </div>
        </b-form>
      </div>
    </section>

    <section class="container oversized-container extra-info-section">
      <div class="row">
        <div class="col-12 col-tabs">
          <b-tabs content-class="mt-3" align="center">

            <b-tab title="Descripción" active v-html="product.description">
            </b-tab>

            <b-tab title="Información adicional" v-html="product.information">
            </b-tab>

            <b-tab title="Envio internacional 14 a 21 dias" v-html="product.international_ship">
            </b-tab>

            <b-tab title="Valoraciones" >

              <div class="col-lg-6 mx-auto col-comment-form">
                <div class="col-12 col-comments">
                  <b-form class="box-comment" @submit="addComment">
                    <div class="box-input">
                      <b-form-textarea v-model="comment.body" placeholder="Escribe tu comentario" required rows="2" max-rows="2"></b-form-textarea>

                      <p class="mt-2 text-right">
                        <b-button type="submit" class="btn-co">Enviar valoracion</b-button>
                      </p>
                    </div>
                  </b-form>
                </div>
              </div>
              <div class="col-lg-6 mt-3 col-all-comments">
                <div class="wr-comments" v-if="product.comments.length">
                  <div class="row">
                    <div class="col-12 col-comments">

                      <div class="row">
                        <div class="col-lg-12 col-comment" v-for="(item, coprInx) in product.comments" :key="'coprInx-'+coprInx">
                          <div class="box" >

                            <div class="box-comment f-w-600 text-uppercase">{{ item.comments }}</div>
                            <div class="box-comment d-block pl-3" > {{ item.created }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </b-tab>
          </b-tabs>
        </div>

        <!-- <div class="col-lg-10 col-extra">
          <p class="mb-3">
            <img src="public/images/pages/products/extra-1.jpg">
          </p>
          <p class="mb-3">
            <img src="public/images/pages/products/extra-2.png">
          </p>
          <p class="mb-3">
            <img src="public/images/pages/products/extra-3.jpg">
          </p>
        </div> -->
      </div>
    </section>

    <section class="container oversized-container related-products-section" id="related-products" v-if="isLoading == false">
      <div class="row">
        <div class="col-12 col-s-title">
          <h2 class="title-s1">Productos relacionados</h2>
          <hr class="mt-2 mb-2" />
        </div>
      </div>

      <div class="col-products">
        <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
          <swiper-slide v-for="(p, pdInx) in products" :key="'pdInx-'+pdInx">
            <div class="col-12 px-0 box-product-sample-s1">
              <div class="box-link">
                <router-link :to="'/producto/'+p.id" style="color: black;text-decoration: none;">
                    <div class="box-image">
                      <img class="placed-backg" src="public/images/shared/empty.png" v-bind:style="{ backgroundImage: 'url('+p.imageUrl+')' }">
                    </div>

                    <div class="box-bubbles">
                      <span class="bubble" v-for="(tag,indx) in p.labels" :key="indx" :style="'background-color:'+tag.color_code+';top:'+tag.toppx">{{ tag.name }}</span>
                    </div>

                    <div class="box-descr">
                      <h6 class="name">{{ p.name }}</h6>

                      <div class="descr" v-html="p.description"> </div>

                      <h6 class="price">
                        <span>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.first_price) }}</span>
                        <span v-if="p.last_price"> - $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.last_price) }}</span>
                      </h6>

                    </div>
                  </router-link>
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </section>

    <sweet-modal blocking hide-close-button ref="modalloading">
      <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
      <div>Cargando ...</div>
    </sweet-modal>

    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">

      <div v-html="modal.msg"></div>
      <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success' ">
          <div v-if="modal.cart == true">
            <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Agregar mas productos</b-button>
            <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
          </div>

      </div>
    </sweet-modal>

  </div>
</template>

<script>


import vZoom from 'vue-zoom'; // https://www.npmjs.com/package/vue-zoom
export default {
  components: {vZoom},

  data() {
    return {
      showDescr: true,
      showModels:true,

      id: null,
      showGallery: true,
      modalGallery: [],
      showModalGallery: false,
      description:null,
      sku_model:null,
      documentUrlCertificate:null,
      form: {
        modelo: null,
        quantity: 1,
        color: null,
        models:[],
        models_id:null,
        models_name:null,
      },

      product: {
        name: '',
        description: '',
        sku: '',
        price_discount: '',
        price_orig: '',
        price: '',
        short_description: '',
        description: '',
        models:[],
        models:[],
        comments:[],
        prices:[],
        labels:[],
      },

      category: [],

      products: [
        { id: 5, imageUrl: 'public/images/pages/products/product-1.jpg', price: '500', priceMax: '50400', name: 'CBD Destilado de amplio espectro libre de THC' },
        { id: 2, imageUrl: 'public/images/pages/products/product-2.jpg', price: '450', priceMax: '36500', name: 'CBD Destilado de espectro completo' },
        { id: 3, imageUrl: 'public/images/pages/products/product-3.jpg', price: '496', priceMax: '64000', name: 'Destilado de CBD-O Vapes [0% THC]' },
        { id: 4, imageUrl: 'public/images/pages/products/product-1.jpg', price: '419', priceMax: '68000', name: 'CBD Destilado de amplio espectro libre de THC' },
        { id: 6, imageUrl: 'public/images/pages/products/product-2.jpg', price: '419', priceMax: '68000', name: 'CBD Destilado de espectro completo' },
      ],

      gallery: [],

      relatedProducts: [],
      stock: 0,
      isLoading: false,

      modal:{
        msg:'',
        icon:'',
        block:false,
        cart:false,
      },

      // == Carrusel options ==
      galleryOptions: {
        loop: false,
        speed: 600,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }

        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // }
      },

      productsOption: {
        loop: false,
        slidesPerView: 5,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1600: {
            slidesPerView: 5,
          },
          1200: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          576: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1
          },
        }
      },

      modalGalleryOptions: {
        loop: true,
        speed: 750,
        // effect: 'fade',

        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      price: 0,
      priceMax: 68000,
      price_orig:null,
      price_discount:null,
      comment:{
        body:null,
      },
      formcomatografia:{
            company:null,
            description:null,
            reference:null,
            weight:null,
            ml:null,
            lote:null,
            comments:null,
            no_guide:null,


          }
      // == ==
    }
  },

  watch: {
        "$route.params.id" : function(v){
            //this.id = this.$route.params.id;
            this.id = this.$root._getURLID(this.$route.params.id);
            this.getProduct();
        },
        'form.quantity':function(){
            var price_ = 0;
            var price_orig_ = 0;
            for (let z = 0; z < this.product.models.length; z++) {
                if(this.form.models_id == this.product.models[z]['id']){
                    price_ = this.product.models[z]['price'];
                    price_orig_ = this.product.models[z]['price_orig'];
                }
            }

            var hasdiscount = false;
            for (let x = 0; x < this.product.prices.length; x++) {
                if(this.product.prices[x]['quantity_minimum'] <= this.form.quantity && this.product.prices[x]['quantity_maximum'] >= this.form.quantity ){
                  price_orig_ =  price_;
                  price_ = price_orig_ - ( price_orig_ * (this.product.prices[x]['discount'] / 100));
                  hasdiscount = true;
                }
            }
            this.price = price_;
            this.price_orig = price_orig_;


        }
    },

  methods:{
    openModalGallery(galleryArray){
      this.modalGallery = galleryArray;

      this.$refs['modal-image'].show();

      setTimeout(()=>{
        this.showModalGallery = true;
      },700);
    },

    getProduct(){
      this.showDescr = false;
      this.$root.isLoading = true;
       this.showGallery = false; // DESCOMENTAR ESTO
       axios.get('https://extractoseum.online/api/products/' + this.id).then((response)=>{
      // axios.get(tools.url('/api/products/' + this.id)).then((response)=>{
        this.product = [];
        this.gallery = [];

        this.product = response.data;

        //this.category = response.data.category;

        //this.stock = this.product.stock;

        this.showGallery = true;
        this.getRelated(this.id);


        if(this.product.models.length > 0){
            this.price = this.product.models[0]['price'];
            this.price_orig = this.product.models[0]['price_orig'];
            this.description = this.product.models[0]['description'];
            this.sku_model = this.product.models[0]['sku'];
            this.documentUrlCertificate = this.product.models[0]['documentUrlCertificate'];

            this.stock = this.product.models[0]['stock'];
            this.form.models_id = this.product.models[0]['id'];
            this.form.modelo = this.product.models[0]['id'];
            this.form.models_name = this.product.models[0]['name'];
            this.gallery = this.product.models[0]['gallery'].concat(this.product['gallery']);
        }
        this.$root.isLoading = false;
      }).catch((error)=>{
        console.log(error);
        this.$root.isLoading = false;
      });
    },

    getRelated(id){
      axios.get(tools.url('/api/products/related/'+id)).then((response)=>{
        this.products = response.data;

      }).catch((error)=>{
        console.log(error);
      })
    },

    addCart(evt){
      evt.preventDefault();
      if(this.form.models_id == null){
        this.modal.msg = 'Debes de seleccionar una presentacion';
        this.modal.icon = 'warning';
        this.$refs.modal.open();
        return;
      }
      var sumaaxu = 0;
      var encontradoaux = false;
      var cartaux = [];
      if(localStorage.cart){
          cartaux = JSON.parse(localStorage.getItem('cart'));
          for(var i = 0; i < cartaux.length ; i++){
              if(cartaux[i].id == this.id && cartaux[i].models_id == this.form.models_id){
                  sumaaxu = parseInt(cartaux[i].quantity) + parseInt(this.form.quantity);
                  encontradoaux = true;
                  break;
              }
          }
          if(!encontrado){
              sumaaxu = parseInt(this.form.quantity);
          }
      }
      else{
        sumaaxu = parseInt(this.form.quantity);
      }
      if(sumaaxu > this.stock){
        this.modal.msg = 'La cantidad selecciona supera al stock actual';
        this.modal.icon = 'warning';
        this.$refs.modal.open();
        return;
      }
      var cart = [];
      var encontrado = false;
      if(localStorage.cart){
          cart = JSON.parse(localStorage.getItem('cart'));

          for(var i = 0; i < cart.length ; i++)
          {
              if(cart[i].id == this.id && cart[i].models_id == this.form.models_id)
              {
                  var suma = parseInt(cart[i].quantity) + parseInt(this.form.quantity);
                  cart[i].quantity = suma <= this.stock ? suma : this.stock;
                  encontrado = true;
                  break;
              }
          }

          if(!encontrado)
          {
              cart.push({ id:this.id, quantity:this.form.quantity, models_id: this.form.models_id });
          }
      }
      else
      {
          cart.push({ id:this.id, quantity:this.form.quantity, models_id: this.form.models_id });
      }
      if(this.id == 41){

        localStorage.setItem("comatografia",JSON.stringify(this.formcomatografia));
      }




      localStorage.setItem("cart",JSON.stringify(cart));
      this.$root.cartCount = cart.length;
      //this.toast();
      this.modal.cart = true;
      this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito';
      this.modal.icon = 'success';
      this.$refs.modal.open();
    },
    noPaste(evt){
      event.preventDefault();
    },

    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    changeCantidad($type){
      this.form.quantity = parseInt(this.form.quantity);
      if ($type == '-') {
        this.form.quantity = (this.form.quantity > 1) ? --this.form.quantity : 1;
      }
      else{
        this.form.quantity = (this.form.quantity < 100) ? ++this.form.quantity : 100;
      }
    },
    changeModelid(indx,models_id){
        this.showGallery = false;
        this.price = this.product.models[indx]['price'];
        this.price_orig = this.product.models[indx]['price_orig'];
        this.description = this.product.models[indx]['description'];
        this.sku_model = this.product.models[indx]['sku'];
        this.documentUrlCertificate = this.product.models[indx]['documentUrlCertificate'];
        this.stock = this.product.models[indx]['stock'];
        this.form.models_id = models_id;
        this.form.models_name = this.product.models[indx]['name'];
        this.showGallery = true;
        this.gallery = this.product.models[indx]['gallery'].concat(this.product['gallery']);
        this.form.modelo = models_id;

    },
    addComment(event) {

      this.$refs.modalloading.open();
      event.preventDefault();
        axios.post(tools.url("/api/comments"),{products_id:this.id,comments:this.comment.body}).then((response) => {
            this.$refs.modalloading.close();
            this.comment.body = '';
            this.modal.cart = false;
            this.modal.block = false;
            this.modal.msg = 'Información guardada correctamente';

            this.$refs.modal.open();
            this.getProduct();
        }).catch((error) => {
          this.$refs.modalloading.close();
            this.modal.icon = 'error';
            this.modal.block = false;
            this.modal.msg = 'Error al guardar informacin';

        })
    },
  },

   mounted(){
    // this.id = this.$route.params.id;
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getProduct();
  }
}
</script>
